module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"visible columns":"Visible columns"},"de":{"visible columns":"Sichtbare Spalten"}}')
  delete Component.options._Ctor
}
